import React from "react";

export default function SelectionMenu({ options, selected, setSelected }) {
  return (
    <div className="selectionmenu">
      {options.map((option) => {
        return (
          <div
            className={
              "menubutton" + (selected == option ? " selectedbutton" : "")
            }
          >
            <button onClick={() => setSelected(option)}>{option}</button>
          </div>
        );
      })}
    </div>
  );
}
